import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e5e51694")

_pushScopeId("data-v-e5e51694")
const _hoisted_1 = {
  "data-testid": "pickup-schedule-config-section-schedule",
  class: "w-full flex flex-col py-3 px-4 bg-white rounded-xl card-border"
}
const _hoisted_2 = { class: "mb-4 flex flex-col items-start justify-between gap-1 sm:flex-row sm:items-center sm:gap-4" }
const _hoisted_3 = { class: "text-base font-bold" }
const _hoisted_4 = {
  "data-testid": "pickup-schedule-config-note-max-slots",
  class: "text-xs text-gray-lp-500"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RegularScheduleSection = _resolveComponent("RegularScheduleSection")!
  const _component_SpecialScheduleSection = _resolveComponent("SpecialScheduleSection")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("pickup.scheduleConfig.scheduleSectionTitle")), 1),
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("pickup.scheduleConfig.regular.maxSlotsNote")), 1)
    ]),
    _createVNode(_component_RegularScheduleSection, {
      enabled: _ctx.enabledValue,
      "onUpdate:enabled": _cache[1] || (_cache[1] = ($event: any) => (_ctx.enabledValue = $event)),
      days: _ctx.dayValues,
      "onUpdate:days": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dayValues = $event)),
      loading: _ctx.loading,
      slotStartHour: _ctx.slotStartHour,
      slotEndHour: _ctx.slotEndHour,
      slotIntervalMinutes: _ctx.slotIntervalMinutes
    }, null, 8, ["enabled", "days", "loading", "slotStartHour", "slotEndHour", "slotIntervalMinutes"]),
    _createVNode(_component_SpecialScheduleSection, {
      enabled: _ctx.specialEnabledValue,
      "onUpdate:enabled": _cache[3] || (_cache[3] = ($event: any) => (_ctx.specialEnabledValue = $event)),
      dates: _ctx.specialDateValues,
      "onUpdate:dates": _cache[4] || (_cache[4] = ($event: any) => (_ctx.specialDateValues = $event)),
      loading: _ctx.loading,
      slotStartHour: _ctx.slotStartHour,
      slotEndHour: _ctx.slotEndHour,
      slotIntervalMinutes: _ctx.slotIntervalMinutes
    }, null, 8, ["enabled", "dates", "loading", "slotStartHour", "slotEndHour", "slotIntervalMinutes"])
  ]))
})